import { css } from '@emotion/css';

import { m } from '../../motif/m';

export const emphasizedTextCss = css`
  color: ${m('--emphasized-text-color')};
  font-style: normal;
`;
